module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"page-title":"Categories","actress-type":"Girl Types","play-type":"Play","costume-type":"Costume","site-specific-type":"Other"},"ja":{"page-title":"カテゴリー","actress-type":"タイプ","play-type":"プレイ内容","costume-type":"コスチューム","site-specific-type":"その他"}}')
  delete Component.options._Ctor
}
